<template>
    <toolbar-option>
        <template slot="primary">
            <toggle v-model="isChecked" :messages="messages" @change="setChangedData(true)" />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CHECKED_ATTR_NAME = 'checked-by-default';

export default {
    name: 'input-checked',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Checked By Default',
            isChecked: false,

            messages: {
                checked: 'Yes',
                unchecked: 'No',
            },
        };
    },

    watch: {
        isChecked() {
            this.selectedElements[0].setElementData(CHECKED_ATTR_NAME, this.isChecked);
            this.onOptionChange(this.isChecked);
        },
    },

    methods: {
        onSelectedElement() {
            this.isChecked = !!this.selectedElements[0].getElementData(CHECKED_ATTR_NAME);
        },
    },
};
</script>
